import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// Components
import { ReceivingReportFormComponent } from '@app/modules/purchase-orders/receiving-report-form/receiving-report-form.component';

@Component({
  selector: 'cnc-transfer-order-form',
  templateUrl: './transfer-order-form.component.html',
  styleUrls: ['./transfer-order-form.component.scss'],
})
export class TransferOrderFormComponent implements OnInit {
  constructor(private modalService :NgbModal) {}

  ngOnInit() :void {}

  bulkReceiveUpdatedItems(event :any) :void {
    const modalRef = this.modalService.open(ReceivingReportFormComponent, {
      size: 'lg',
      windowClass: 'po-rr-modal',
    });

    if (event?.poItems.length > 0) {
      modalRef.componentInstance.totalShippingCost = event.totalShippingCost ?? 0;
      modalRef.componentInstance.lineItemsFromPO = event.poItems;
    }
  }
}
